export default (state = {}) => {
  return {
    ...state,
    loginLoading: false,
  };
};
